jQuery(document).ready(function($) {

    /*
     * Ajax Contact Form Handler
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $(function() {
        
        var form     = $('#contact-form');
        var formMssg = form.find('.form-messages');
        var sendBttn = form.find('.btn-send');

        $(form).submit(function(e) {

            e.preventDefault();
            e.stopPropagation();

            if ($(this).get(0).checkValidity() === true) {

                grecaptcha.ready(function() {
                    grecaptcha.execute('6LfyHXgsAAAAABsFiqLv4rNBIMrIK4iDRlE22_dc', {
                        action: 'introspective_contact_form_handler'
                    }).then(function(token) {

                        if (! token) {
                            grecaptcha.reset();
                            return null;
                        }

                        var gRecaptchaResponse = form.find('.g-recaptcha-response');
                        gRecaptchaResponse.val(token);

                        var formData = $(form).serialize();

                        $.ajax({
                            type: 'POST',
                            url: PayaraAjax.ajax_url,
                            data: {
                                'action': 'introspective_contact_form_handler',
                                'formdata': formData
                            },
                            beforeSend: function() {
                                console.log(formData);
                                $(sendBttn).prop('disabled', true);
                            },
                        })
                        .done(function(response) {
                            console.log(response);
                            $(sendBttn).prop('disabled', false);
                            $(formMssg).removeClass('d-none error').addClass('success').text(response);
                            $('.form-control').val('');
                            form.removeClass('was-validated');
                        })
                        .fail(function(data) {
                            $(sendBttn).prop('disabled', false);
                            $(formMssg).removeClass('d-none success').addClass('error');
                            if (data.responseText !== '') {
                                $(formMssg).text(data.responseText);
                            } else {
                                $(formMssg).text('An error occured and your message could not be sent. Please try again.');
                            }
                        });
                    });
                });
            }
            form.addClass('was-validated');
        });
    });

    /*
     * Ajax Request Consultation Form Handler
     *
     * Bacon ipsum dolor amet tenderloin cow tongue,
     * filet mignon kielbasa brisket salami biltong.
     */
    $(function() {
        
        var form     = $('#request-consultation-form');
        var formMssg = form.find('.form-messages');
        var sendBttn = form.find('.btn-send');

        $(form).submit(function(e) {

            e.preventDefault();
            e.stopPropagation();

            if ($(this).get(0).checkValidity() === true) {

                grecaptcha.ready(function() {
                    grecaptcha.execute('6LfyHXgsAAAAABsFiqLv4rNBIMrIK4iDRlE22_dc', {
                        action: 'introspective_book_valuation_form_handler'
                    }).then(function(token) {

                        if (! token) {
                            grecaptcha.reset();
                            return null;
                        }

                        var gRecaptchaResponse = form.find('.g-recaptcha-response');
                        gRecaptchaResponse.val(token);

                        var formData = $(form).serialize();

                        $.ajax({
                            type: 'POST',
                            url: PayaraAjax.ajax_url,
                            data: {
                                'action': 'introspective_book_valuation_form_handler',
                                'formdata': formData
                            },
                            beforeSend: function() {
                                console.log(formData);
                                $(sendBttn).prop('disabled', true);
                            },
                        })
                        .done(function(response) {
                            console.log(response);
                            $(sendBttn).prop('disabled', false);
                            $(formMssg).removeClass('d-none error').addClass('success').text(response);
                            $('.form-control').val('');
                            form.removeClass('was-validated');
                            $('#request-consultation-modal').modal('hide');
                        })
                        .fail(function(data) {
                            $(sendBttn).prop('disabled', false);
                            $(formMssg).removeClass('d-none success').addClass('error');
                            if (data.responseText !== '') {
                                $(formMssg).text(data.responseText);
                            } else {
                                $(formMssg).text('An error occured and your message could not be sent. Please try again.');
                            }
                        });
                    });
                });
            }
            form.addClass('was-validated');
        });
    });
});
